const Constants = {
  BASE_PATH: 'https://api.openweathermap.org/data/2.5',
  WEATHER_PATH: '/weather',
  WEATHER_PARAM: 'q=',
  API_ID: 'appid=',
  API_KEY: 'df382371f71a920bf67ae5a538a05596',
  UNITS_NAME: 'units=',
  UNITS_PARAM: 'metric'
};

export default Constants;
